// Implements: F-UIX-018, F-USG-005, F-USG-006
/**
 * `/backoffice/usage` — "Mi consumo" (UIX.4), the target of the 80 % notice's link.
 *
 * The page only composes: the reads and the sections live in the `backoffice` module's
 * `MyUsageContainer`. The person is the session's, never an address or a query value, and
 * the container is keyed by that person's id (checklist 14): another person signing in on
 * the same tab mounts a fresh one.
 */

import type { ReactElement } from "react";

import { MyUsageContainer } from "../../modules/backoffice/containers/MyUsageContainer";
import { useSession } from "../../shared/api/session";
import { useTranslation } from "../../shared/i18n";
import { PageHeader } from "../../shared/ui/molecules/PageHeader";

export function MyUsagePage(): ReactElement | null {
  const { t } = useTranslation();
  const { state } = useSession();
  // `RequireSession` renders this page only for a session; nothing to show otherwise.
  if (state.status !== "authenticated") return null;
  const { user, scopes } = state.view;

  return (
    <section>
      <PageHeader title={t("backoffice.myUsage.title")} subtitle={t("backoffice.myUsage.intro")} />
      <MyUsageContainer key={user.id} personId={user.id} scopes={scopes} />
    </section>
  );
}
